import MyApplication from './myApplication';

export default MyApplication;



// WEBPACK FOOTER //
// ./src/views/applicationClient/index.js